export enum ReferralClientTypeOptionKey {
  INDIVIDUAL = 'individual',
  COUPLES = 'couples'
}
